<template>
  <div class="app-container">
    <div class="filter-serarch-container">
      <div>
        <vxe-button v-waves  :loading="downloadLoading" class="filter-search-item" status="primary" icon="el-icon-circle-plus-outline" @click="handleAdd">新建</vxe-button>
        <vxe-button v-waves  :loading="downloadLoading" class="filter-search-item" status="danger" icon="el-icon-delete" @click="handleDelete">删除</vxe-button>
        <vxe-button v-waves :loading="addLoading" class="filter-search-item" status="success" icon="el-icon-refresh" @click="refresh">刷新</vxe-button>
      </div>
      <div class="search-box">
        <div class="filter-search-item">
          <el-input v-model="formData.nameOrAccount" placeholder="输入类型名称/编码" clearable :style="{ width: '100%' }" @change="handleFilter" />
        </div>
        <vxe-button v-waves status="primary" icon="el-icon-search" class="filter-search-item" @click="handleFilter" style="margin-left:10px">查询</vxe-button>
      </div>
    </div>
    <!-- --- ---- ---- --------------------------------------------->
    <vxe-table
      ref="xTable2"
      border
      show-header-overflow
      show-overflow
      style="margin-top:5px;margin-left:6px"
      class="mytable-scrollbar"
      :column-config="{ resizable: true }"
      stripe
      round
      :loading="listLoading"
      :align="allAlign"
      :scroll-y="{ enabled: false }"
      :row-config="{ isHover: true }"
      :data="tableDealerData"
    >
      <vxe-column type="checkbox" width="60" />
      <vxe-column type="seq" title="序号" width="60" align="center" />
      <vxe-column :visible="false" field="id" title="id" align="center" />
      <vxe-column field="code" title="类型编码" align="center" />
      <vxe-column field="name" title="类型名称" align="center" />
      <vxe-column field="status" title="状态" align="center">
        <template #default="{ row }">
          <span v-if="row.status === '1'">有效</span>
          <span v-else>无效</span>
        </template>
      </vxe-column>
      <vxe-column field="remark" title="备注" align="center" />
      <vxe-column field="creator" title="创建人" align="center" />
      <vxe-column title="操作" align="center" fixed="right">
        <template #default="{ row }">
          <el-link status="primary" icon="el-icon-edit" @click="viewDetail(row)">查看</el-link>
        </template>
      </vxe-column>
    </vxe-table>
    <vxe-pager :loading="listLoading" :current-page="tablePage.currentPage" :page-size="tablePage.pageSize" :total="tablePage.totalResult" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" @page-change="handlePageChange" />
  </div>
</template>

<script>
// import permission from '@/directive/permission/index.js' // 权限判断指令
// import checkPermission from '@/utils/permission' // 权限判断函数
import waves from '@/directive/waves' // waves directive
import { parseTime } from '@/utils'
import { add, getOriganizationDataTree, userAdd } from '@/api/user'
import { findBicList, changeStatus } from '@/api/bicVal'
import axios from 'axios'
// import { getToken } from '@/utils/auth'

const defautFactor = {
  code: '',
  symbol: '',
  values: ''
}

const defautUserAddForm = {
  name: undefined,
  loginno: undefined,
  loginpwd: undefined,
  repeatpwd: undefined,
  domain: undefined,
  roles: undefined,
  department: undefined,
  dataRights: undefined,
  roleIds: undefined
}

const defaultListQuery = {
  page: 1,
  limit: 20,
  domain: 'center',
  conditions: [],
  sort: 'id'
}
// 角色
const defaultRolelistMessage = {
  page: 1,
  limit: 1000000000,
  importance: undefined,
  title: undefined,
  type: undefined,
  conditions: [],
  sort: '+id'
}

const defaultUserDetail = {
  id: undefined,
  name: undefined,
  loginNo: undefined,
  department: undefined,
  rightsNames: undefined,
  rightsIds: undefined,
  roles: undefined,
  roleId: undefined
}

export default {
  name: 'ValueListManagement',
  // inject: ['reload'],
  directives: { waves },
  filters: {},
  data() {
    const validateName = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入姓名'))
      } else if (value.length > 1) {
        let j = 0
        value.split('').forEach(element => {
          if (escape(element).indexOf('%u') < 0) {
            j++
          }
        })
        if (j !== 0 && j !== value.length) {
          callback(new Error('姓名只能全中文或者全英文字母'))
        }
        callback()
      } else {
        callback()
      }
    }
    return {
      tableKey: 0,
      panelName: '高级',
      list: null,
      showSearch: false,
      isCenter: true,
      total: 0,
      allAlign: null,
      DialogVisible: false,
      UserDialogVisible: false,
      factor: Object.assign({}, defautFactor),
      loading: false,
      checkDataRightKeys: [],
      activeDomain: 'center',
      tablePage: {
        currentPage: 1,
        pageSize: 20,
        totalResult: 0
      },
      tableData: [],
      tableDealerData: [],
      tempData: [],
      dataRightTree: [],
      defaultProps: {
        children: 'children', // 指定子树为节点对象的某个属性值
        label: 'objname' // 指定节点标签为节点对象的某个属性值
      },
      UserAddDialogVisible: false,
      filterText: '',
      getRoleData: [], // 角色信息
      forRoleData: {
        nameAccount: ''
      },
      formData: {
        nameOrAccount: ''
      },
      userAddForm: Object.assign({}, defautUserAddForm),
      addrules: {
        name: [{ required: true, trigger: 'blur', validator: validateName }],
        // loginno: [{
        //   required: true,
        //   message: '账号不能为空',
        //   trigger: 'blur'
        // }],
        loginpwd: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ],
        repeatpwd: [
          {
            required: true,
            message: '请输入密码',
            trigger: 'blur'
          }
        ],
        domain: [
          {
            required: true,
            message: '登陆端不能为空',
            trigger: 'change'
          }
        ]
      },
      domainOptions: [
        {
          label: '柳汽厂商',
          value: 'center'
        },
        {
          label: '经销商',
          value: 'dealer'
        }
      ],
      addLoading: false,
      listLoading: false,
      openUserDialog: false,
      listQuery: Object.assign({}, defaultListQuery),
      listMessage: Object.assign({}, defaultRolelistMessage),
      importanceOptions: [1, 2, 3],
      sortOptions: [
        { label: 'ID Ascending', key: '+id' },
        { label: 'ID Descending', key: '-id' }
      ],
      userDetail: Object.assign({}, defaultUserDetail),
      statusOptions: ['published', 'draft', 'deleted'],
      showReviewer: false,
      temp: {
        id: undefined,
        importance: 1,
        remark: '',
        timestamp: new Date(),
        title: '',
        type: '',
        status: 'published'
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: 'Edit',
        create: 'Create'
      },
      dialogPvVisible: false,
      pvData: [],
      rules: {
        type: [{ required: true, message: 'type is required', trigger: 'change' }],
        timestamp: [
          {
            type: 'date',
            required: true,
            message: 'timestamp is required',
            trigger: 'change'
          }
        ],
        title: [{ required: true, message: 'title is required', trigger: 'blur' }]
      },
      downloadLoading: false,
      idData: [] // 通过复选框获取角色id
    }
  },
  created() {
    this.getList()
  },
  activated() {
    this.getList() 
  },
  methods: {
    // checkPermission,
    showSearchPane() {
      this.showSearch = !this.showSearch
      this.$forceUpdate()
    },
    getList() {
      this.listLoading = true
      findBicList(this.listQuery).then(res => {
        if (res.code === 1 && res.data) {
          this.tableDealerData = res.data.list
          // console.log('后台返回的数据')
          // console.log(res.data.list)
          this.tablePage.totalResult = res.data.total
          this.listLoading = false
        } else {
          this.listLoading = false
          this.$message.error(res.message)
        }
      }).finally(()=> this.listLoading = false)
    },
    commitadd() {
      this.$refs['userAddForm'].validate(valid => {
        if (!valid) return
        if (this.userAddForm.loginpwd !== this.userAddForm.repeatpwd) {
          this.$message.warning('两次输入密码不一致')
          return
        }
        userAdd(this.userAddForm).then(res => {
          if (res.code === 1) {
            this.$message.success('新增成功')
            this.UserAddDialogVisible = false
            this.userAddForm = Object.assign({}, defautUserAddForm)
          }
        })
      })
    },
    handleClick(tab) {
      this.listQuery.domain = tab.name
      this.getList()
    },
    // 获取用户id
    editEvent(row) {
      // this.DialogVisible = true
      this.UserDialogVisible = true
      this.userDetail = Object.assign({}, row)
      // const param = {
      //   sysUser: row.id
      // }
      // getUserDataRiht(param).then(res => {
      // })
      getOriganizationDataTree().then(res => {
        if (res.code === 1) {
          this.dataRightTree = res.data
        }
      })
      if (this.userDetail.rightsIds) {
        this.checkDataRightKeys = this.userDetail.rightsIds.split(',')
      }
    },
    // formatJson(filterVal) {
    //   let exportData = this.tableData
    //   if (this.$refs.xTable.getCheckboxRecords().length !== 0) {
    //     exportData = this.$refs.xTable.getCheckboxRecords()
    //   }
    //   return exportData.map((v) =>
    //     filterVal.map((j) => {
    //       if (j === 'timestamp') {
    //         return parseTime(v[j])
    //       } else {
    //         return v[j]
    //       }
    //     })
    //   )
    // },
    handlePageChange({ currentPage, pageSize }) {
      this.tablePage.currentPage = currentPage
      this.tablePage.pageSize = pageSize
      this.listQuery.limit = pageSize
      this.listQuery.page = currentPage
      this.getList()
    },
    handleFilter() {
      this.listQuery.page = 1
      if (this.formData.nameOrAccount && this.formData.nameOrAccount !== '') {
        const nameCondition = {
          'code': 'name',
          'symbol': 'like',
          'values': this.formData.nameOrAccount
        }
        const codeCondition = {
          'code': 'code',
          'symbol': 'like',
          'values': this.formData.nameOrAccount
        }
        this.listQuery.conditions[0] = nameCondition
        this.listQuery.conditions[1] = codeCondition
        this.getList()
      } else {
        this.refresh()
      }
    },
    // 角色模糊查询
    roleUpdata() {
      this.listMessage.page = 1
      this.factor.code = 'nameAccount'
      this.factor.values = this.forRoleData.nameAccount
      this.listMessage.conditions[0] = this.factor
    },
    refresh() {
      this.listQuery = Object.assign({}, defaultListQuery)
      if (this.listQuery.conditions.length > 0) {
        this.listQuery.conditions.length = 0
      }
      this.getList()
      // this.reload()
    },
    removeEvent() {
      this.$confirm('删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$message.warning('删除功能未开发，请到原系统更改')
        })
        .catch(() => {
          this.$message.info('已经取消删除')
        })
    },
    handleCreate() {
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleDelete() {
      const tableData = this.$refs.xTable.getCheckboxRecords().length === 0 ? this.$refs.xTable2.getCheckboxRecords() : this.$refs.xTable.getCheckboxRecords()
      if (tableData.length === 0) {
        this.$message.warning('请勾选一条记录')
      } else {
        this.$confirm('将状态修改成无效, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            console.log(tableData)
            const code = tableData.map(item => item.code).join(',')
            const domain = this.listQuery.domain
            const param = {
              'code': code,
              'domain': domain
            }
            changeStatus(param).then(res => {
              if (res.code === 1) {
                this.$message.success('修改成功')
                this.refresh()
              }
            })
          })
          .catch(() => {
            this.$message.info('取消重置')
          })
      }
    },
    // 后端导出Excel
    exportExcelBack() {
      const data = {
        url: 'CUSTOMER-SERVE/auth/user-info/export',
        data: this.listQuery,
        fileName: '用户信息表'
      }
      this.exportExcelData(data)
    },
    exportExcelData(params) {
      this.downloadLoading = true
      const param = params.data
      axios({
        method: 'post',
        url: process.env.VUE_APP_BASE_API + params.url,
        // headers里面设置token
        headers: {
          'X-token': ''
        },
        data: param,
        // 二进制流文件，一定要设置成blob，默认是json
        responseType: 'blob'
      }).then(res => {
        const link = document.createElement('a')
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' })
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.setAttribute('download', `${params.fileName}.xlsx`)
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        this.downloadLoading = false
        return true
      })
    },
    add() {
      this.openUserDialog = true
      add().then(res => {
        if (res.code === 1) {
          this.$message.success('保存成功')
        }
      })
      this.openUserDialog = false
    },
    handleAdd() {
      this.$router.push({
        // path: `bicValDetail/null/${this.listQuery.domain}`
        path: `/comm/bicValDetail/null/${this.listQuery.domain}`
        // /comm/bicValDetail
      })
    },
    viewDetail(row) {
      this.$router.push({
        path: `bicValDetail/${row.id}/${this.listQuery.domain}`
      })
    },
    handleDownload() {
      if (this.$refs.xTable.getCheckboxRecords().length === 0) {
        this.$confirm('不勾选则全量导出表数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.exportExcelBack()
          })
          .catch(() => {
            this.$message.info('已经取消导出')
          })
      } else {
        this.exportExcelFont()
      }
    },
    // 前端导出
    exportExcelFont() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['用户姓名', '用户账号', '所属部门', '角色']
        const filterVal = ['name', 'loginNo', 'department', 'roles']
        const data = this.formatJson(filterVal)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '用户信息表'
        })
        this.$message.success('导出成功')
        this.downloadLoading = false
      })
    },
    formatJson(filterVal) {
      let exportData
      if (this.listQuery.domain === 'dealer') {
        exportData = this.tableDealerData
        if (this.$refs.xTable2.getCheckboxRecords().length !== 0) {
          exportData = this.$refs.xTable2.getCheckboxRecords()
        }
      } else {
        exportData = this.tableData
        if (this.$refs.xTable.getCheckboxRecords().length !== 0) {
          exportData = this.$refs.xTable.getCheckboxRecords()
        }
      }
      return exportData.map(v =>
        filterVal.map(j => {
          if (j === 'timestamp') {
            return parseTime(v[j])
          } else {
            return v[j]
          }
        })
      )
    },
    getSortClass: function(key) {
      const sort = this.listQuery.sort
      return sort === `+${key}` ? 'ascending' : 'descending'
    }
  }
}
</script>
<style lang="less" scoped>
.table-header-class {
  background-color: blue;
  color: blue;
}
.filter-serarch-container {
  display: flex;
  justify-content: space-between;
}
.search-box {
  display: flex;
  align-items: center;
}
/deep/ .el-input__inner {
  height: 30px;
}
// ::v-deep .el-form-item__label {
//   line-height: 36px;
// }
</style>
